import React from 'react';
import PropTypes from 'prop-types';

export default function YearMonthDropDownHelper(props) {
  const {
    date,
    localeUtils,
    onChange,
    fromDate = new Date(1971, 0),
    toDate = new Date(new Date().getFullYear(), 11)
  } = props;
  const months = localeUtils.getMonths();
  const years = [];
  for (let i = fromDate.getFullYear(); i <= toDate.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()}>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
}

YearMonthDropDownHelper.propTypes = {
  date: PropTypes.object,
  localeUtils: PropTypes.object,
  onChange: PropTypes.func,
  fromDate: PropTypes.object,
  toDate: PropTypes.object
};
